
import React from 'react';
import { Language } from '../App';

interface NavbarProps {
  lang: Language;
  setLang: (l: Language) => void;
}

const Navbar: React.FC<NavbarProps> = ({ lang, setLang }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center shrink-0">
            <a 
              href="https://defibank.digital" 
              className="flex items-center hover:opacity-80 transition-opacity"
            >
              <img 
                src="https://i.imgur.com/VYool5N.png" 
                alt="DeFi Bank Logo" 
                className="h-8 md:h-10 w-auto object-contain"
              />
            </a>
          </div>

          <div className="flex items-center gap-2 md:gap-6">
            {/* Language Selector Toggle - Agora visível em mobile */}
            <div className="flex bg-zinc-900/50 border border-white/10 rounded-lg p-0.5 items-center">
              <button 
                onClick={() => setLang('pt')}
                className={`px-2 md:px-3 py-1 rounded-md text-[9px] md:text-[10px] font-black tracking-widest transition-all ${lang === 'pt' ? 'bg-zinc-800 text-white shadow-lg' : 'text-zinc-500 hover:text-zinc-300'}`}
              >
                PT
              </button>
              <button 
                onClick={() => setLang('en')}
                className={`px-2 md:px-3 py-1 rounded-md text-[9px] md:text-[10px] font-black tracking-widest transition-all ${lang === 'en' ? 'bg-zinc-800 text-white shadow-lg' : 'text-zinc-500 hover:text-zinc-300'}`}
              >
                EN
              </button>
            </div>

            <div className="flex items-center gap-1.5 md:gap-4">
              <a 
                href="https://app.defibank.digital/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/5 hover:bg-white/10 text-white px-2.5 md:px-5 py-2 rounded-full text-[8px] md:text-xs font-black uppercase tracking-widest transition-all border border-white/10"
              >
                Wallet
              </a>
              <a 
                href="https://t.me/Ceo_RHT"
                target="_blank"
                rel="noopener noreferrer"
                className="gradient-bg hover:brightness-110 text-white px-3 md:px-8 py-2 rounded-full text-[8px] md:text-xs font-black uppercase tracking-widest transition-all btn-glow transform hover:scale-105 min-w-[65px] md:min-w-[80px] text-center"
              >
                {lang === 'pt' ? 'Listar' : 'List'}
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
